import { marketingAdministratorRoles } from "../config/roles";
import { ABTestMetric, ABTestWinnerType } from "../config/enums";
import { enumToOptions } from "../blocks/fields/enumToOptions";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/abtest";

const metricOptions = enumToOptions(ABTestMetric);
const winnerTypeOptions = enumToOptions(ABTestWinnerType);

/**
 * The A/B tests list. Every test comes back in one request, so its filters narrow what
 * is already loaded.
 */
export const abtestsListDefinition: ListDefinition = {
  path: "/abtests",
  entityName: "g4c_abtest",
  recordRoute,
  title: "A/B Tests",
  allowedRoles: marketingAdministratorRoles,
  data: "all-at-once",
  filters: [
    {
      name: "Name",
      label: "Name",
      kind: "text",
      searchFields: ["Name"],
      width: "wider",
    },
    {
      name: "g4c_communicationaid",
      label: "Communication A",
      kind: "lookup",
      lookupEntity: "g4c_communication",
      searchable: true,
    },
    {
      name: "g4c_communicationbid",
      label: "Communication B",
      kind: "lookup",
      lookupEntity: "g4c_communication",
      searchable: true,
    },
    {
      name: "g4c_metric",
      label: "Metric",
      kind: "picklist",
      options: metricOptions,
    },
    {
      name: "hideExpired",
      label: "Hide Expired A/B Tests",
      kind: "boolean",
      defaultValue: true,
      hidePast: "g4c_enddate",
    },
    {
      name: "g4c_startdate",
      label: "Start Date",
      kind: "date-range",
      advanced: true,
    },
    {
      name: "g4c_enddate",
      label: "End Date",
      kind: "date-range",
      advanced: true,
    },
    { name: "createdon", label: "Created", kind: "date-range", advanced: true },
    {
      name: "modifiedon",
      label: "Modified",
      kind: "date-range",
      advanced: true,
    },
  ],
  filterByStatus: true,
  allowAdd: true,
  allowStatusEdit: true,
  defaultSortKey: "g4c_startdate",
  defaultSortDir: "desc",
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 300,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    {
      key: "statuscode",
      label: "Status",
      width: 200,
      sortable: true,
      display: "component",
      componentKey: "abTestStatus",
    },
    {
      key: "g4c_communicationaid",
      label: "Communication A",
      width: 200,
      sortable: true,
    },
    {
      key: "g4c_communicationbid",
      label: "Communication B",
      width: 200,
      sortable: true,
    },
    {
      key: "g4c_metric",
      label: "Metric",
      width: 200,
      sortable: true,
      display: "picklist",
      options: metricOptions,
    },
    {
      key: "g4c_winnertype",
      label: "Winner Type",
      width: 200,
      sortable: true,
      display: "picklist",
      options: winnerTypeOptions,
    },
    {
      key: "g4c_testpercentage",
      label: "Test Percentage",
      width: 200,
      sortable: true,
    },
    {
      key: "g4c_startdate",
      label: "Start Date",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "g4c_enddate",
      label: "End Date",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "g4c_testperiodenddate",
      label: "Test Period End Date",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "modifiedon",
      label: "Modified On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
